<div class="m-3 border">border</div>
<div class="m-3 border-top">border-top</div>
<div class="m-3 border-bottom">border-bottom</div>
<br>
<br>
<br>
<br>
<div class="ms-4"></div>
<div class="me-3"></div>
<div class="p-4">
  <form>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleInputPassword1">Password</label>
      <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password">
    </div>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleInputEmail1">Email address</label>
      <input type="email" class="form-control Vazirmatn" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
      <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
    </div>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleInputEmail1">مدیریت</label>
      <input type="text" class="form-control" id="exampleInputText1" aria-describedby="textHelp" placeholder="متن خود را وارد کنید">
      <small id="textHelp" class="form-text text-muted">We'll never share your text with anyone else.</small>
    </div>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="customCheck1">
      <label class="form-check-label" for="customCheck1">شماره</label>
    </div>
    <div class="form-check">
      <input type="radio" id="customRadio1" name="customRadio" class="form-check-input">
      <label class="form-check-label" for="customRadio1">وزن</label>
    </div>
    <div class="form-check">
      <input type="radio" id="customRadio2" name="customRadio" class="form-check-input">
      <label class="form-check-label" for="customRadio2">شهر</label>
    </div>
    <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
      <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label>
    </div>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleFormControlSelect1">Example select</label>
      <select class="form-select" id="exampleFormControlSelect1">
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4</option>
        <option>5</option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleFormControlSelect2">Example multiple select</label>
      <select multiple class="form-select" id="exampleFormControlSelect2">
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4</option>
        <option>5</option>
      </select>
    </div>
    <div class="form-group mb-3">
      <label class="form-label" for="exampleFormControlTextarea1">Example textarea</label>
      <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
    </div>


    <div class="form-check">
      <input type="radio" id="customRadio1" name="customRadio" class="visually-hidden">
      <label class="form-check-label" for="customRadio1">وزن</label>
    </div>
  </form>


  <div class="accordion" id="accordionExample">
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          Accordion Item #1
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          Accordion Item #2
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header" id="headingThree">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
          Accordion Item #3
        </button>
      </h2>
      <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
        </div>
      </div>
    </div>
  </div>
</div>
